module.exports = __webpack_public_path__ + "img/footer-lg.ebce1e74.png";